export enum RugbyLeaguePenaltyKickGoalAttribute {
  Golden = 2992,
}
